import GoogleMap from '../Google'
import { SearchControlProps } from '../Google/FilterControl'
import MapLibre from '../MapLibre'
import { FilterControlProps } from '../MapLibre/FilterControl'
import { useInnmaxMap } from '../Provider'
import { MapType } from '../map.types'

type InnmaxFilterControlProps = {
  google?: SearchControlProps
  maplibre?: FilterControlProps
}

const InnmaxFilterControl = (props: InnmaxFilterControlProps) => {
  const { mapPlatform, mapType } = useInnmaxMap()
  const { google = {}, maplibre = {} } = props

  if (mapType === MapType.Upload || mapPlatform === 'MapLibre') {
    return <MapLibre.FilterControl {...maplibre} />
  }

  return <GoogleMap.FilterControl {...google} />
}

export default InnmaxFilterControl
